import { RolesTypeEnum } from "../models/roles/roles.model";

export const roleNameByKey: Record<string, string> = {
  client_manager: "Manager/Verwalter",
  client: "Standortleiter",
  client_worker: "Techniker",
  client_unpaid: "Unbezahlter Account",
};

export const allowedRolesToChangeMibiSettings = [
  RolesTypeEnum.ClientManager,
  RolesTypeEnum.ClientWorker,
  RolesTypeEnum.ClientUnpaid];


export const clientRoles = [
  RolesTypeEnum.Client,
  RolesTypeEnum.ClientWorker,
  RolesTypeEnum.ClientUnpaid,
  RolesTypeEnum.ClientManager
];